import Vue from 'vue'
import ElementUI from 'element-ui';
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta';
import './assets/tailwind.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'element-ui/lib/theme-chalk/index.css';
import _ from 'lodash'

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueMeta);

Vue.mixin({
    data() {
        return {
            isSmallScreen: false
        }
    },
    mounted() {
        this.checkScreenSize()
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        checkScreenSize() {
            this.isSmallScreen = window.innerWidth < 768
        },
        handleResize: _.throttle(function () { // ʹ��lodash����
            this.checkScreenSize()
        }, 100)
    }
})
new Vue({
    store,
  router,
  render: h => h(App),
}).$mount('#app')
